import React from "react";

const map = {
  green: {
    bg: "bg-[#E1ECDD]",
    text: "text-[#4F6F52]",
    dot: "bg-[#4F6F52]",
    label: "Stable",
  },
  yellow: {
    bg: "bg-[#F5EBD9]",
    text: "text-[#8C7A4F]",
    dot: "bg-[#D6C7A1]",
    label: "Needs caution",
  },
  red: {
    bg: "bg-[#F5E6D3]",
    text: "text-[#A86B4A]",
    dot: "bg-[#C99A78]",
    label: "Likely to escalate",
  },
};

export default function RiskBadge({ level = "green" }) {
  const m = map[level] || map.green;
  return (
    <span
      data-testid={`risk-badge-${level}`}
      className={`inline-flex items-center gap-2 ${m.bg} ${m.text} rounded-full px-4 py-1.5 text-xs font-medium tracking-wide`}
    >
      <span className={`w-2 h-2 rounded-full ${m.dot} pulse-soft`} />
      {m.label}
    </span>
  );
}
